import React from "react"
import { css } from "@emotion/react"
import Layout from "../components/layout"
import Seo from "../components/seo"

const Page = () => {
  return (
    <Layout>
      <Seo />
      <div css={design}>
        <h1>『 作って学ぶ　HTML＆CSSモダンコーディング 』</h1>
        <p>
          <a href="https://ebisu.com/html-css-modern-coding/">書籍情報ページ</a>
        </p>
      </div>
    </Layout>
  )
}

const design = css`
  display: grid;
  height: 80vh;
  justify-items: center;
  align-content: center;
  gap: 60px;
  text-align: center;

  a {
    color: #428bca;
  }
  a:hover {
    opacity: 0.8;
  }
`

export default Page
